"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultValues = void 0;
const getDefaultValues = (components, formState) => {
    const smartComponents = [...components.body, ...components.banner];
    const bodyValues = smartComponents.reduce((values, item) => {
        const storeData = formState[item.props.name];
        return Object.assign(Object.assign({}, values), { [item.props.id]: Object.assign(Object.assign(Object.assign({}, item.props.value), (storeData ? storeData : {})), (item.props.skipValidation ? { isValid: true } : {})) });
    }, {});
    return Object.assign({}, bodyValues);
};
exports.getDefaultValues = getDefaultValues;
